import Icon from "@react-native-vector-icons/material-design-icons/static";
import { Dialog, Text } from "react-native-paper";
import type { IconType } from "../../icon";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import Button from "../Button";
import DialogWrapper from "../DialogWrapper";

type Props = {
	open: boolean;
	handleClose: () => void;
	title: string;
	description: string;
	cta: string;
	appFont?: string;
};

const ConfidenceListItem = ({
	variant,
	appFont = "opensans",
}: {
	variant: "high" | "medium" | "low";
	appFont?: string;
}) => {
	const theme = useAppTheme();
	const icons: Record<string, IconType> = {
		high: "emoticon-happy-outline",
		medium: "emoticon-neutral-outline",
		low: "emoticon-sad-outline",
	};
	return (
		<Box display="flex" flexDirection="row" alignItems="center" marginTop={16}>
			<Box
				height={48}
				backgroundColor={theme.palette.confidence[variant]}
				width={88}
				display="flex"
				flexDirection="row"
				alignItems="center"
				justifyContent="center"
				borderRadius={24}
				marginRight={16}
			>
				<Icon name={icons[variant]} color={theme.colors.white} size={30} />
			</Box>
			<Text allowFontScaling={false} style={{ fontSize: 16 }}>
				<Text
					variant="bodyMedium"
					style={{
						textTransform: "capitalize",
						fontFamily: `${appFont}-semibold`,
					}}
				>
					{variant}
				</Text>{" "}
				confidence
			</Text>
		</Box>
	);
};

const TutorialDialog = ({
	open,
	handleClose,
	title,
	description,
	cta,
	appFont = "opensans",
}: Props) => {
	const { isMobile } = useDevice();

	const confidenceLevels = ["high", "medium", "low"] as const;
	return (
		<DialogWrapper
			visible={open}
			handleClose={handleClose}
			maxWidth="xs"
			width={isMobile ? "80%" : 380}
		>
			<Dialog.Icon icon="emoticon-happy-outline" />
			<Dialog.Title
				allowFontScaling={false}
				style={{
					textAlign: "center",
				}}
			>
				{title}
			</Dialog.Title>
			<Dialog.Content>
				<Box gap={8}>
					<Text variant="bodyMedium" allowFontScaling={false}>
						{description}
					</Text>
					<Box gap={8}>
						{confidenceLevels.map((variant) => (
							<ConfidenceListItem
								key={variant}
								variant={variant}
								appFont={appFont}
							/>
						))}
					</Box>
				</Box>
			</Dialog.Content>
			<Dialog.Actions>
				<Button onPress={handleClose}>{cta}</Button>
			</Dialog.Actions>
		</DialogWrapper>
	);
};

export default TutorialDialog;
